import * as PIXI from 'pixi.js';
import { globalData } from './globalData';
import { config } from './appConfig';
// import { Spine } from 'pixi-spine';
import { gameAssets, setSessionExpired } from './gameUI';
import { playCrateCrash, playTrafficConeCrash, playTurtleCrash } from './soundManager';
import { tweenFadeAppear } from './utility';
import { pixiApp } from './initializePixi';

export const PopUpType = ["NETWORK ERROR", "INSUFFICIENT BALANCE", "MANUAL"]

export class popUp {

    popUpContainer = null;
    popUpGraphic = null;
    text = null;
    closeButton = null
    dimmer = null
    chicken = null

    description = null;

    constructor(x, y, width = 1000, height = 600, arch = 30) {

        this.popUpContainer = new PIXI.Container();
        this.popUpContainer.x = x;
        this.popUpContainer.y = y
        this.popUpContainer.initialX = x;
        this.popUpContainer.initialY = y + 100;
        this.popUpContainer.finalX = x;
        this.popUpContainer.finalY = y;
        this.popUpContainer.visible = false;

        this.dimmer = new PIXI.Sprite(PIXI.Assets.get('dimmer'))
        this.dimmer.anchor.set(0.5)
        this.dimmer.scale.set(1.5)
        this.popUpContainer.addChild(this.dimmer)
        // this.popUpGraphic = new PIXI.Graphics();
        // this.popUpGraphic.lineStyle(20, 0xDEB182, 1);
        // this.popUpGraphic.beginFill(0x301813, 1);
        // this.popUpGraphic.drawRoundedRect(-width / 2, -height / 2, width, height, arch);
        // this.popUpGraphic.endFill();
        this.popUpGraphic = new PIXI.Sprite(PIXI.Assets.get('pop_up_board'))
        this.popUpGraphic.anchor.set(0.5)
        this.popUpGraphic.scale.set(2)


        // this.popUpGraphic.x = x;
        // this.popUpGraphic.y = y;

        this.popUpContainer.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') { this.closePopUp() }
        })
        this.popUpContainer.addChild(this.popUpGraphic);
        this.createText();
        //    this.popUpContainer.visible = false;
        this.closeButton = new PIXI.Sprite(PIXI.Assets.get('close_b_normal'))
        this.closeButton.anchor.set(0.5)
        this.closeButton.scale.set(0.5)
        this.closeButton.x = this.popUpGraphic.width * 0.25 - this.closeButton.width * 0.5
        this.closeButton.y = -this.popUpGraphic.height * 0.25 + this.closeButton.height * 0.5
        this.popUpGraphic.addChild(this.closeButton)

        this.chicken = new PIXI.Sprite(PIXI.Assets.get('chicken_cry'))
        this.chicken.scale.set(1.5)
        this.chicken.anchor.set(0.5)
        this.chicken.y = -225
        this.popUpContainer.addChild(this.chicken)

        const backgroundDim = new PIXI.Graphics();
        backgroundDim.beginFill(0, 0.4);
        backgroundDim.drawRoundedRect(-500, 200, 1000, 180, 30);
        backgroundDim.endFill();

        const style = new PIXI.TextStyle({
            dropShadow: false,
            dropShadowBlur: 0,
            dropShadowColor: "#252525",
            dropShadowDistance: 0,
            stroke: "#000000",
            strokeThickness: 0,
            fill: "#999999",
            fontFamily: "Arial",
            fontSize: 36,
            fontWeight: "600",
            align: "center",
        });

        this.description = new PIXI.Text("", style);
        this.description.anchor.set(0.5);
        this.description.y = 290
        this.description.text = "! Not enough balance"

        backgroundDim.addChild(this.description);

        this.popUpContainer.addChild(backgroundDim);

    }

    createText() {
        this.text = new PIXI.BitmapText("INSUFFICIENT\nBALANCE", {
            fontName: 'normal-font',
            fontSize: 47,
            align: 'center',
            letterSpacing: -5,
            resolution: 2 //-72,

        });
        this.text.anchor.set(0.5)
        this.text.y = 62
        this.text.scale.set(0.6)
        this.popUpContainer.addChild(this.text);
    }

    popUp(popUpText = "TEXT HERE", description = "! Not enough balance") {
        tweenFadeAppear(this.popUpContainer, true)
        this.text.text = popUpText;
        if (popUpText.includes("INSUFFICIENT")) {
            this.description.style = { ...this.description.style, fontSize: 26 };
        } else {
            this.description.style = { ...this.description.style, fontSize: 36 };
        }
        this.description.text = description;
        this.popUpContainer.interactive = true;
    }

    closePopUp() {
        tweenFadeAppear(this.popUpContainer, false)
        this.popUpContainer.interactive = false;

        if (globalData.tokenExpired) {
            // window.location.replace("http://3.211.81.248:8006/");
            setSessionExpired();
        }
    }


}